// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","bg":"Modal_bg__-rBSl","content":"Modal_content__gGb69","fadeIn":"Modal_fadeIn__-PTjN","close":"Modal_close__V34Fj"};